import React from 'react';

import { calculateValue } from './analyseUtils';
import { IMetric } from 'store/entity/IAnalyticResponse';

import { InfoBoxWrapper, InfoBox } from './styles';
import { convertNumbersToProperFormat, isANumber } from '../../utils/number';
import { ISeries, Metric } from 'store/survey/surveyTypes';
import { ReportOverride } from './ChartViewer';

interface IComponentProps {
  analyseMetrics: IMetric | null;
  queryMetric: Metric;
  series: ISeries;
  reportOverride?: ReportOverride;
}

const BoxChart: React.FC<IComponentProps> = ({
  analyseMetrics,
  queryMetric,
  series,
  reportOverride,
}) => {
  const value = calculateValue(
    analyseMetrics ? analyseMetrics[`${queryMetric}Score`] : NaN
  );
  return (
    <InfoBoxWrapper>
      <InfoBox bgColor={reportOverride?.chartColor ?? series?.color}>
        <span>
          {analyseMetrics && isANumber(value)
            ? convertNumbersToProperFormat(value, 3)
            : '---'}
        </span>
      </InfoBox>
    </InfoBoxWrapper>
  );
};

export default BoxChart;
